(function($){
    $('body').on('submit', '#directorist_helgent_config', function (e) {
        var submitButton = this.querySelector(".directorist-btn-profile-save");
        submitButton.classList.add('hdi_loading');
        
        e.preventDefault();
        var form_data = $( this ).serialize();

        $.post(
            DHGDashboardScriptData.ajax_url,
            form_data,
            function (response) {
                submitButton.classList.remove('hdi_loading');
                if ( ! response.success ) {
                    $('#directorist-user-config-notice').html('<span class="directorist-alert directorist-alert-danger">' + response.data.message + '</span>');
                } else {
                    $('#directorist-user-config-notice').html('<span class="directorist-alert directorist-alert-success">' + response.data.message + '</span>');
                }
            },
            'json'
        );

    });

    $('body').on('click', '.wpwax-vm-note__single .wpwax-vm-note__single--label', function (e) {
        // Get the text to copy
        var text = this.innerText;
      
        // Use the Clipboard API to write the text to the clipboard
        navigator.clipboard.writeText(text);

        const toggleText = document.createElement("span");
        toggleText.classList.add("toggle-text");
        toggleText.innerHTML = "Text Copied";

        this.appendChild(toggleText);

        setTimeout(() => {
            toggleText.classList.add("fadeOut")
            setTimeout(() => {
                toggleText.remove();
            }, 500);
        }, 1000);
    });

})(jQuery);